import React, { useState } from 'react';
import axios from 'axios';
import * as API from '../../../Endpoints/endpoint';
import './../../PosterData/postertable.css';
import { useNavigate } from 'react-router-dom';

function AddPoster() {
  const [formData, setFormData] = useState({
    srno: '',
    chartname: '',
    photopdf: '',
    language: '',
    voice: '',
    video: '',
    summary: ''
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(API.POST_SINGLE_POSTER, formData);
      alert('Poster added successfully!');
      navigate('/posterdata'); 
    } catch (err) {
      console.error('Error adding poster:', err);
      alert('Failed to add poster.');
    }
  };

  return (
    <div className="form-container">
      <h2>Add Poster</h2>
      <form onSubmit={handleSubmit}>
        {Object.keys(formData).map((field) => (
          <div className="form-group" key={field}>
            <label>{field.toUpperCase()}</label>
            <input
              type="text"
              name={field}
              value={formData[field]}
              onChange={handleChange}
              required={field !== 'video' && field !== 'summary' && field !== 'photopdf'}
            />
          </div>
        ))}

        <div className="form-buttons">
          <button type="submit" className="btn-submit">Submit</button>
          <button type="button" className="btn-cancel" onClick={() => navigate('/posterdata')}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddPoster;
